import { FC, useState, useEffect } from "react";
import { Input } from "antd";

import Icon from "@assets/icon_config";
import "./textArea.scss";
import { getNoteMaxLength } from "@utils/helpers";

const { TextArea } = Input;

type TAreaProps = {
  changeHandler?: any;
  content?: any;
  actionsMenu?: any;
  autoFocus?: any;
  disabled?: any;
  wordLimit?: Number;
  showCount?: Boolean;
  placeHolder?: any;
};

const TextAreaComp: FC<TAreaProps> = ({ content, changeHandler, actionsMenu, autoFocus, disabled, wordLimit, showCount = false, placeHolder="Enter Some Text" }: TAreaProps) => {
  const [textAreaValue, setTextAreaValue] = useState(content);

  useEffect(()=>setTextAreaValue(content), [content]);
  
  const onChange = (e: any) => {
    setTextAreaValue(e?.target?.value);
    changeHandler(e?.target?.value);
  };
  return (
    <div className="textArea">
      <TextArea
        style={{ width: "100%", height: "100%", fontSize: "16px", fontWeight: "500", padding: "11px", resize: "none" }}
        value={textAreaValue}
        disabled={disabled}
        placeholder={placeHolder}
        onChange={onChange}
        className="custom-scroll-bar"
      />
      {showCount ? (
        <div className="textArea__word-count-container">
          {textAreaValue?.trim()?.length > getNoteMaxLength() ? (
            <span className="textArea__word-count-container__limit">
              <Icon name="hrainfo" />
            </span>
          ) : null}
          <div className={`textArea__word-count-container__count ${textAreaValue?.trim()?.length > getNoteMaxLength() ? "word-limit-reached-indicator" : ""}`}>
            {textAreaValue?.trim()?.length ? textAreaValue?.trim()?.length : 0}/{wordLimit}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default TextAreaComp;
